import {locales} from '~/data/locales'
import getAvailableSites from '~/queries/available-sites-for-tower.gql'

export getLocaleFromRoute = (route) ->
  # Extract locale from route path like /jp/page-japanese
  pathSegments = route.path.split('/').filter (segment) -> segment.length > 0

  # Check if first segment is a valid locale code
  if pathSegments.length > 0
    potentialLocale = pathSegments[0]

    # Define your supported locales
    supportedLocales = ['jp']

    if potentialLocale in supportedLocales
      return potentialLocale

  # Return default locale if no valid locale found
  return undefined # or whatever your default is

export getTowerURIFromLocalizedPath = (path, site) ->
	if !site || !path then return path
	return path.replace "#{site}/", ""

export getAvailableSitesForTower = (uri, craft) ->
	entries = await craft.getEntries
		query: getAvailableSites
		variables:
			uri: uri
			site: locales.map (locale) -> locale.siteHandle

	return entries.map (entry) -> entry.siteHandle
